/**
 * Tương đương công thức cũ `min(66, round(gridCells * 1.1))` với ô 10 m — giữ phạm vi mỗi zone khi đổi bước lưới (đồng bộ `FLOOD_GRID_CELL_SIZE_M` trong `floodDepthScale`).
 */
export const SYNTHETIC_GRID_MAX_CELLS_PER_SIDE = 132;
export const SYNTHETIC_GRID_CELLS_FACTOR = 2.2;
